import { useLanguage } from '../i18n/LanguageContext';

export default function TermsAndConditions() {
  const { t } = useLanguage();
  const sections = Array.isArray(t.documents.sections) ? t.documents.sections : [];
  const fallbackParagraphs = [t.documents.paragraph1, t.documents.paragraph2, t.documents.paragraph3].filter(Boolean);

  return (
    <div className="terms-page">
      <div className="page-header documents-page">
        <h1>{t.documents.title}</h1>
        {t.documents.intro && <p>{t.documents.intro}</p>}

        {sections.map((section) => (
          <section key={section.title} className="document-section">
            {section.title && <h2>{section.title}</h2>}
            {Array.isArray(section.paragraphs) &&
              section.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
            {Array.isArray(section.bullets) && section.bullets.length > 0 && (
              <ul>
                {section.bullets.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
          </section>
        ))}

        {sections.length === 0 &&
          fallbackParagraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
      </div>
    </div>
  );
}
